// What is running, so "has it deployed yet?" has an answer.
//
// It comes from package.json and nowhere else, because that file is COMMITTED
// and therefore survives the shallow checkout the deploy makes. Counting git
// commits looked tidier and answered 1 on every build forever, a number that
// never moved dressed as one that did.
//
// `npm run push` increments it; the pre-push hook refuses a push that did not.
// The commit and the build time are on the hover.

declare const __BUILD__: { version: string; sha: string; at: string } | undefined;

export interface Build {
  version: string;
  sha: string;
  at: string;
}

/** `dev` under vitest, where there is no define and no deploy to check. */
export const BUILD: Build =
  typeof __BUILD__ === 'undefined'
    ? { version: '0.0.0', sha: 'dev', at: new Date(0).toISOString() }
    : __BUILD__;

/** `v0.2.59` — straight from package.json, which `npm run push` increments. */
export function versionLabel(build: Build = BUILD): string {
  return `v${build.version}`;
}

/** The whole truth, for the tooltip. */
export function buildTitle(build: Build = BUILD): string {
  const when = new Date(build.at);
  const stamp = Number.isNaN(when.getTime()) || when.getTime() === 0 ? 'unknown' : when.toLocaleString();
  return `gTables ${versionLabel(build)}\nBuild ${build.sha}, made ${stamp}`;
}
